import guest from '@/middleware/guest'

export default [
  {
    path: '/login',
    name: 'login',
    meta: { middleware: guest },
    component: () => import(/* webpackChunkName: "login" */ '@/pages/Login.vue')
  }
]
